const UnreadMessageCount = ({ count }) => {
    return (
        <div className='bg-[#FF0000] w-6 h-6 rounded-full flex items-center justify-center text-white font-semibold'>
            {count > 99 ? '99+' : count}
        </div>
    );
};

export default UnreadMessageCount;
